<script>
import PUserView        from './p-user-view'
import PUserUpdate      from './p-user-update'
import PUserPass        from './p-user-pass'
import PUserAdd         from './p-user-add'
import { getBaseUrl }   from '../../utils/'

const NotFound = { template: '<p>Página não encontrada</p>' }

const routes = {
    [getBaseUrl() + '/editar-usuario.php']      : PUserView,
    [getBaseUrl() + '/editar-usuario.php#edit'] : PUserUpdate,
    [getBaseUrl() + '/editar-usuario.php#password'] : PUserPass,
    [getBaseUrl() + '/editar-usuario.php#add-user'] : PUserAdd
}

export default {
  data: function() {
      return {
        currentRoute: window.location.pathname + window.location.hash
      }
  },
  computed: {
    ViewComponent () {
      return routes[this.currentRoute] || NotFound
    }
  },
  render (h) {
      return h(this.ViewComponent)
  },
}
</script>



// WEBPACK FOOTER //
// src/js/components/profile/p-user-router.vue